//Effects
import { all, put, takeLatest } from "redux-saga/effects";

//Service
import { defaultApi } from "../../utils/axiosApi";

//Constants
import {
  CHECK_ONBOARDING_STATUS,
  CHECK_ONBOARDING_STATUS_SUCCESS,
  CHECK_ONBOARDING_STATUS_FAILURE,
  COMPLETE_ONBOARDING,
  COMPLETE_ONBOARDING_SUCCESS,
  COMPLETE_ONBOARDING_FAILURE,
  REQUEST_ORGANIZATION_LIST,
} from "../../modules/constants";

// Check onboarding status
export function* checkOnboardingStatus() {
  try {
    let url = `onboarding/check/`;
    const response = yield defaultApi(url, "GET");
    yield put({
      type: CHECK_ONBOARDING_STATUS_SUCCESS,
      payload: { data: response.data },
    });
  } catch (err) {
    yield put({
      type: CHECK_ONBOARDING_STATUS_FAILURE,
      payload: err,
    });
  }
}

// Complete onboarding
export function* completeOnboarding({ payload }) {
  if (!payload) return;
  try {
    let url = `onboarding/`;
    const response = yield defaultApi(url, "POST", payload);
    yield put({
      type: COMPLETE_ONBOARDING_SUCCESS,
      payload: { data: response.data },
    });

    // Fetch organization list to populate Redux and localStorage
    yield put({ type: REQUEST_ORGANIZATION_LIST });
  } catch (err) {
    yield put({
      type: COMPLETE_ONBOARDING_FAILURE,
      payload: err,
    });
  }
}

export default function* root() {
  yield all([
    takeLatest(CHECK_ONBOARDING_STATUS, checkOnboardingStatus),
    takeLatest(COMPLETE_ONBOARDING, completeOnboarding),
  ]);
}
